import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import SearchInput from "@/components/widgets/common/SearchInput.vue"
import { useSearch } from "@/hooks/useSearch"
import { useUtilities } from "@/hooks/useUtilities"
import UploadFileForm from "@/modules/Missions/components/Details/Documents/UploadFileForm.vue"
import Previewable from "@/components/layout/Previewable.vue"
import DocumentList from "@/modules/Missions/components/Details/Documents/DocumentList.vue"
import { useQuery } from "@vue/apollo-composable"
import {
  DocumentsQuery,
  DocumentsQueryQuery,
  MissionDocument,
  MissionLifecycleFragmentFragment,
  ConsultantMissionLifecycle,
} from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'Documents',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment | ConsultantMissionLifecycle
}



const uploadFileForm = ref(null)

const refetchQueries = computed(() => {
  return [
    {
      query: DocumentsQuery,
      variables: {
        filter: {
          missionLifecycleId: props.mission.id,
        },
      },
    },
  ]
})

const documents = ref<MissionDocument[] | null>(null)
const cachedDocuments = ref<MissionDocument[] | null>(null)
const searchKey = ref("")
const showAddFileModal = ref(false)

const showPreviewable = ref(false)
const activeDocument = ref<MissionDocument | null>(null)
const { getPreviewableType } = useUtilities()

const setActiveDocument = (document: MissionDocument) => {
  activeDocument.value = document
}

const togglePreviewable = () => {
  showPreviewable.value = !showPreviewable.value
}

const onViewFile = (document: MissionDocument) => {
  setActiveDocument(document)
  togglePreviewable()
}

const recentlyUpdatedFiles = computed(() => {
  if (!cachedDocuments.value) return []

  const now = Date.now()
  const last24Hours = 48 * 60 * 60 * 1000

  return cachedDocuments.value.filter((document) => {
    const updatedAt = new Date(document.updatedAt).getTime()
    return now - updatedAt <= last24Hours
  })
})

const { loading, onResult } = useQuery<DocumentsQueryQuery>(DocumentsQuery, {
  filter: {
    missionLifecycleId: props.mission.id,
  },
})

onResult((result) => {
  if (result.data?.missionDocuments?.data) {
    documents.value = result.data.missionDocuments.data as MissionDocument[]
    cachedDocuments.value = result.data.missionDocuments.data as MissionDocument[]
  }
})

watch(searchKey, (searchKey) => {
  if (!documents.value) return

  if (!searchKey) {
    documents.value = cachedDocuments.value
  } else {
    documents.value = searchDocuments(searchKey)
  }
})

const searchDocuments = (searchTerm: string) => {
  if (!cachedDocuments.value) return []
  return useSearch({ items: cachedDocuments.value, search: searchTerm, fields: ["name"] })
}

const onOpenAddFileModal = () => {
  showAddFileModal.value = true
}

const onDismissFileModal = () => {
  ;(uploadFileForm.value as any)?.resetForm()
  activeDocument.value = null
  showAddFileModal.value = false
}

const onClosePreviewable = () => {
  activeDocument.value = null
  showPreviewable.value = false
}

return { __sfc: true,props, uploadFileForm, refetchQueries, documents, cachedDocuments, searchKey, showAddFileModal, showPreviewable, activeDocument, getPreviewableType, setActiveDocument, togglePreviewable, onViewFile, recentlyUpdatedFiles, loading, onResult, searchDocuments, onOpenAddFileModal, onDismissFileModal, onClosePreviewable, Icon, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent, SearchInput, UploadFileForm, Previewable, DocumentList }
}

})